export const GET_COMPANIES = "GET_COMPANIES";
export const GET_CURRENT_COMPANY = "GET_CURRENT_COMPANY";
export const UPDATE_CURRENT_COMPANY = "UPDATE_CURRENT_COMPANY";
export const GET_COMPANY_BY_ID = "GET_COMPANY_BY_ID";
export const UPDATE_COMPANY = "UPDATE_COMPANY";
export const DELETE_COMPANY = "DELETE_COMPANY";
export const CREATE_COMPANY = "CREATE_COMPANY";
export const UPLOAD_SIGNATURE = "UPLOAD_SIGNATURE";
export const UPLOAD_LOGO = "UPLOAD_LOGO";
